const API_PATH = '/api/studio-access';

async function request(method = 'GET', body = null, query = '') {
  const response = await fetch(`${API_PATH}${query}`, {
    method,
    credentials: 'same-origin',
    headers: body ? { 'Content-Type': 'application/json' } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(payload?.error || `Studio access service returned ${response.status}`);
    error.status = response.status;
    throw error;
  }
  return payload;
}

export function loadCurrentStudioAccess() {
  return request();
}

export function loadStudioUsers() {
  return request('GET', null, '?scope=all');
}

export function saveStudioUser(access) {
  return request('PUT', access);
}

export function hasStudioRole(access, role) {
  return Boolean(access?.roles?.includes('platform_admin') || access?.roles?.includes(role));
}

export function visibleTrusts(access, trusts) {
  if (access?.roles?.includes('platform_admin')) return trusts;
  const assigned = new Set(access?.trustIds || []);
  return trusts.filter((trust) => assigned.has(trust.id));
}

export function visibleLocales(access, locales) {
  if (access?.roles?.includes('platform_admin')) return locales;
  const assigned = new Set(access?.localeCodes || []);
  return locales.filter((locale) => assigned.has(locale.code));
}
